import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { AlertError } from '../../../components/bootstrap/AlertError';
import Loading from '../../../components/general/Loading';
import { SubTemplate } from '../../../components/general/SubTemplate';
import { handleError, isNotBusinessError } from '../../../utils/handleError';
import {changeEmailService} from "../../../rest/user";
import {ChangeEmailForm} from "../../../components/user/ChangeEmailForm";
import {AlertSuccess} from "../../../components/bootstrap/AlertSuccess";
import {FormattedMessage} from "react-intl";

export function ChangeEmail() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [submited, setSubmited] = useState(false);

  const changeEmail = async (values, setSubmitting) => {
    setLoading(true);
    try {
      await changeEmailService(values.keycloakId, values.email);
      setSubmited(true);
      setSubmitting(false);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  function handleSubmit(values, setSubmitting) {
    setSubmitting(true);
    changeEmail(values, setSubmitting);
  }

  if (loading) {
    return <Loading />;
  }

  if (error && isNotBusinessError(error)) {
    return handleError(error);
  }



  return (
    <SubTemplate hasBackButton titleId={'email.change.title'}>
      <div className={'container'}>
        <div className={'row'}>
          <div className={'col-lg-8 offset-lg-2'}>
            <AlertError error={error} />
            {submited && (
                <AlertSuccess
                    header={<FormattedMessage id='alert.header.changeEmailSubmitted'/>}
                    message={<FormattedMessage id='alert.message.changeEmailSubmitted'/>}
                />
            )}
            <ChangeEmailForm
              onSubmit={handleSubmit}
            />
          </div>
        </div>
      </div>
    </SubTemplate>
  );
}
